import React, { Component } from "react";
import { connect } from "react-redux";
import logo from "../assets/Worldline-Coconut-Horizontal.png";
import { redirectToLogout } from "./redirectActions";

class NavPane extends Component {
  logout() {
    this.props.dispatch(redirectToLogout());
    console.log("logging out...");
  }
  render() {
    return (
      <nav className="nav-pane">
        <a href="/">
          <img src={logo} alt="logo" style={{ width: "135px" }} />
        </a>
        <div className="log-out" onClick={() => this.logout()}>
          Log out
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (_state) => {
  return {};
};
export default connect(mapStateToProps)(NavPane);
